import React from 'react';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { FormattedMessage } from 'react-intl';
import { Tag } from '@superops/ui-design-system';
import { translateText } from '@nile/components';
import { ServiceCatalogItem } from 'Pages/ServiceCatalogNew/types';
import { isEmpty } from 'lodash';

function LinkCell(props) {
  const { cell } = props;
  const { actions } = cell?.column;
  const rowData: ServiceCatalogItem = cell?.row?.original;

  const isDefault: boolean =
    rowData?.serviceTypeItem?.hourlyServiceTypeItem?.defaultItem;

  const inactiveItem: boolean = rowData?.status === 'INACTIVE';

  const integrations = [];
  if (!isEmpty(rowData?.integrationState)) {
    Object.entries(rowData.integrationState)?.forEach((integration) => {
      const isIntegrated = integration?.[1];
      if (isIntegrated) {
        const integrationName = `${integration?.[0]}`;
        integrations.push(integrationName);
      }
    });
  }

  function editServiceItem() {
    if (actions?.onClick && rowData?.status === 'ACTIVE') {
      actions.onClick(rowData);
    }
  }

  return cell?.value ? (
    <div className="fx actr g10 wrap ellipsis">
      <span
        className={`${rowData?.status === 'INACTIVE' ? '' : 'linkText'}`}
        onClick={editServiceItem}
      >
        {cell?.value}
      </span>
      {(isDefault || inactiveItem) && (
        <Tag
          children={translateText(
            inactiveItem ? 'common.inactive' : 'invoice.status.default'
          ).toUpperCase()}
        />
      )}
      {integrations?.length > 0 && (
        <>
          {integrations.map((integration) => {
            return <Tag children={integration} />;
          })}
        </>
      )}
    </div>
  ) : (
    <DisabledTag>
      <FormattedMessage id="app.noData.message" />
    </DisabledTag>
  );
}

export default LinkCell;
